import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UtilisateurService } from '../../_services/UtilisateurService';
import { GlobalService } from '../../_services/GlobalService';
import { PanelBarItemModel, PanelBarStateChangeEvent } from '@progress/kendo-angular-layout';

@Component({
  selector: 'app-menu-admin',
  templateUrl: './menu-admin.component.html',
  styleUrls: ['./menu-admin.component.scss']
})
export class MenuAdminComponent {

  public menu: any[] = [
    { label: "Comptes", route: "/admin/comptes" },
    { label: "Sociétés", route: "/admin/societes" },
    { label: "Crémations", route: "/admin/commandes" },
    // { label: "Propriétaires", route: "/admin/clients" },
    { label: "Housses", route: "/admin/sacs" },
    { label: "Étiquettes", route: "/admin/etiquettes" },
    { label: "Inventaire Cabinets", route: "/admin/inventaireCabinet" },
    { label: "Inventaire Phoenix", route: "/admin/inventairePhoenix" },
    { label: "Tournées", route: "/admin/tournees" },
    { label: "Facturation", route: "/admin/facturation" },
    { label: "Mon compte", route: "/admin/moncompte" },
  ];

  public menuVeterinaire: any[] = [
    { label: "Crémations", route: "/commandes" },
    { label: "Inventaire Cabinet", route: "/inventaireCabinet" },
    { label: "Mon compte", route: "/moncompte" },
    { label: "Bon de commande des housses", route: "/BonCommande" },
  ];

  public selectedMenu = "";
  public router: Router;

  constructor(
    router: Router,
    public _GlobalService: GlobalService,
    public _UtilisateurService: UtilisateurService
  ) {
    this.router = router
  }
  async ngOnInit() {
    this._GlobalService.utilisateur = (await this._UtilisateurService.GetInfosUser()).objet;

    this.selectedMenu = this.router.url;
  }
  //choix menu
  public stateChange(data: PanelBarStateChangeEvent) {
    const focusedEvent: PanelBarItemModel = data.items.filter(
      (item) => item.focused === true
    )[0];

    let route = this.menu.filter(
      (item) => item.label === focusedEvent.title
    )

    if (!this._GlobalService.isAdmin()) {
      route = this.menuVeterinaire.filter(
        (item) => item.label === focusedEvent.title
      )
    }

    if (route[0].route == "/BonCommande") {
      let urlFichier = "/assets/BonCommandePhoenix.pdf"

      let a = document.createElement("a")
      a.target = "_blank"
      a.href = urlFichier
      a.click()

    } else {
      this.router.navigate([route[0].route]);
    }
  }

}
